import { action, observable } from 'mobx';
import { ICreateProjectPOST } from 'cd-eft/models/Projects/createProject';
import { timeOfConcLagCalc } from '../../../business/EFH2/timeOfConcLagCalc';
import { noSpecialChars } from '../../../utils/noSpecialChars';
import DelineateWatershedGpApi from 'cd-eft/services/DelineateWatershedGpApi/DelineateWatershedGpApi';
import stores from '../../../models/Stores';
import {
  IEfh2RainHydgsByIdData,
  IRainfallByIdData,
  IRainfallGridResponse,
  IRainfallTypeListResponse,
} from 'cd-eft/models/EFH2/rainfall';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import { ProjectDataObject } from 'cd-eft/models/Projects/projectsLibrary';
import {
  EftProjectController,
  UserInputsController,
  ProjectCommentController,
  EftProjUserInputController,
  MetadataController,
  ProjectAttachmentController,
} from 'cd-eft/services/eftPrjAdminApi';
import { Efh2ControllerApi, HydroControllerApi } from 'cd-eft/services/eftEfh2Api';
import { Efh2InputParamsDeciSSReq, HydrologyReportReqDto, StateCounty } from 'cd-eft/_codegen_/openapi-generator/eft-efh2';
import { ActivityLogController } from 'cd-eft/services/eftSetApi';
import { UserIdentity } from 'cd-eft/security/UserIdentity';
import { ProjectAttachmentDto } from 'cd-eft/_codegen_/openapi-generator/eft-prjadmin';

const AppStore = stores.AppStore;

export class BasicDataFormVM {
  history;
  activityViewModel;
  watershedApi;
  constructor(history: any, activityViewModel) {
    this.history = history;
    this.activityViewModel = activityViewModel;
    this.watershedApi = new DelineateWatershedGpApi();
  }
  standard484String = 'Standard - 484'

  @observable todaysDate = new Date();
  @observable selectCountyRainfall = true;
  @observable hideSlopeCalc = true;
  @observable error = false;
  @observable errorMsg = '';
  @observable isLoading = false;
  @observable disableSubmit = false;
  @observable disableDownloads = false;
  @observable rainfallDistIDLookup = {};
  @observable rainDistOptions: IRainfallTypeListResponse[] = [];
  @observable dimUnitHydrogOptions = [{ name: this.standard484String, id: 0 }];
  @observable counties: any = [];
  @observable allProjectandDesignComments: any = [];
  @observable adjustedCurveNumber: any = AppStore.efh2Store.basicDataForm.adjustRcn ? AppStore.efh2Store.basicDataForm.adjustRcn : '';
  @observable usStates = [
    { name: 'ALABAMA', abbreviation: 'AL' },
    { name: 'ALASKA', abbreviation: 'AK' },
    { name: 'ARIZONA', abbreviation: 'AZ' },
    { name: 'ARKANSAS', abbreviation: 'AR' },
    { name: 'CALIFORNIA', abbreviation: 'CA' },
    { name: 'COLORADO', abbreviation: 'CO' },
    { name: 'CONNECTICUT', abbreviation: 'CT' },
    { name: 'DELAWARE', abbreviation: 'DE' },
    { name: 'DISTRICT OF COLUMBIA', abbreviation: 'DC' },
    { name: 'FLORIDA', abbreviation: 'FL' },
    { name: 'GEORGIA', abbreviation: 'GA' },
    { name: 'HAWAII', abbreviation: 'HI' },
    { name: 'IDAHO', abbreviation: 'ID' },
    { name: 'ILLINOIS', abbreviation: 'IL' },
    { name: 'INDIANA', abbreviation: 'IN' },
    { name: 'IOWA', abbreviation: 'IA' },
    { name: 'KANSAS', abbreviation: 'KS' },
    { name: 'KENTUCKY', abbreviation: 'KY' },
    { name: 'LOUISIANA', abbreviation: 'LA' },
    { name: 'MAINE', abbreviation: 'ME' },
    { name: 'MARYLAND', abbreviation: 'MD' },
    { name: 'MASSACHUSETTS', abbreviation: 'MA' },
    { name: 'MICHIGAN', abbreviation: 'MI' },
    { name: 'MINNESOTA', abbreviation: 'MN' },
    { name: 'MISSISSIPPI', abbreviation: 'MS' },
    { name: 'MISSOURI', abbreviation: 'MO' },
    { name: 'MONTANA', abbreviation: 'MT' },
    { name: 'NEBRASKA', abbreviation: 'NE' },
    { name: 'NEVADA', abbreviation: 'NV' },
    { name: 'NEW HAMPSHIRE', abbreviation: 'NH' },
    { name: 'NEW JERSEY', abbreviation: 'NJ' },
    { name: 'NEW MEXICO', abbreviation: 'NM' },
    { name: 'NEW YORK', abbreviation: 'NY' },
    { name: 'NORTH CAROLINA', abbreviation: 'NC' },
    { name: 'NORTH DAKOTA', abbreviation: 'ND' },
    { name: 'OHIO', abbreviation: 'OH' },
    { name: 'OKLAHOMA', abbreviation: 'OK' },
    { name: 'OREGON', abbreviation: 'OR' },
    { name: 'PENNSYLVANIA', abbreviation: 'PA' },
    { name: 'PUERTO RICO', abbreviation: 'PR' },
    { name: 'RHODE ISLAND', abbreviation: 'RI' },
    { name: 'SOUTH CAROLINA', abbreviation: 'SC' },
    { name: 'SOUTH DAKOTA', abbreviation: 'SD' },
    { name: 'TENNESSEE', abbreviation: 'TN' },
    { name: 'TEXAS', abbreviation: 'TX' },
    { name: 'UTAH', abbreviation: 'UT' },
    { name: 'VERMONT', abbreviation: 'VT' },
    { name: 'VIRGIN ISLANDS', abbreviation: 'VI' },
    { name: 'VIRGINIA', abbreviation: 'VA' },
    { name: 'WASHINGTON', abbreviation: 'WA' },
    { name: 'WEST VIRGINIA', abbreviation: 'WV' },
    { name: 'WISCONSIN', abbreviation: 'WI' },
    { name: 'WYOMING', abbreviation: 'WY' },
  ];
  @observable cellVsCountyBtnsDisabled = true;
  @observable cellRainfallData = {
    prec1: 0,
    prec2: 0,
    prec5: 0,
    prec10: 0,
    prec25: 0,
    prec50: 0,
    prec100: 0,
  };
  @observable countyRainfallData = {};
  @observable projectSaveModalOpen: boolean = false;
  @observable newProjectName: string = '';
  @observable rcnData: any = [];
  @observable enableCountyOnchange = false;
  @observable resultsInputsModified = {
    duh: false,
    rdt: false,
    hydrograph: false,
  };

  // retrieves all necessary data + other init functions
  @action.bound async initPage() {
    this.isLoading = true;
    if (this.dimUnitHydrogOptions.length === 1) { await this.getHydroData() }

    // check for project id in url path
    // sample project id: d6df99c8-1148-4d1c-a452-6e353410094a
    const path = window.location.href;
    const routeProjectId = path.split('/').reverse()[0];
    const currentProject = AppStore.efh2Store.projectsStore.currentProject;

    if (currentProject && currentProject.projectUuid) {
      AppStore.efh2Store.basicDataForm.client = AppStore.efh2Store.projectsStore.currentProject.client;
      AppStore.efh2Store.basicDataForm.practice = AppStore.efh2Store.projectsStore.currentProject.practice;
      AppStore.efh2Store.basicDataForm.state = AppStore.efh2Store.projectsStore.currentProject.state;
      AppStore.efh2Store.basicDataForm.county = AppStore.efh2Store.projectsStore.currentProject.county;
      await this.getUserInputs(currentProject.projectUuid);
      await this.getAllProjectComments(currentProject.projectUuid);

      // Only load saved result if there are no user inputs already there.
      if (
        AppStore.efh2Store.basicDataForm.runoffCN === 0 &&
        AppStore.efh2Store.basicDataForm.watershedLen === 0 &&
        AppStore.efh2Store.basicDataForm.drainageArea === 0 &&
        AppStore.efh2Store.basicDataForm.watershedSlope === 0
      ) {
        await this.loadProjectUserInput(currentProject.projectUuid);
      }
    } else if (routeProjectId && routeProjectId.length === 36) {
      await this.getProject(routeProjectId);
      await this.loadProjectUserInput(routeProjectId);
      await this.getCountiesFromState(AppStore.efh2Store.basicDataForm.state, false);
    } else {
      // no project found - restore from whats found in user prefs
      await this.getUserPrefs();
      await this.getCountiesFromState(AppStore.efh2Store.basicDataForm.state, true);
      this.isLoading = false;
    }
    // restore user name
    if (AppStore.efh2Store.basicDataForm.user === '') {
      AppStore.efh2Store.basicDataForm.user = String(localStorage.getItem('username') || '');
    }

    await this.calcToC('lag');

    if (
      AppStore.efh2Store.basicDataForm.runoffCN !== 0 &&
      AppStore.efh2Store.basicDataForm.watershedLen !== 0 &&
      AppStore.efh2Store.basicDataForm.drainageArea !== 0 &&
      AppStore.efh2Store.basicDataForm.watershedSlope !== 0
    ) {
      await this.handleSubmit();
    }

    this.isLoading = false;
  }
  private async getProject(projectId) {
    try {
      const rspns: any = await EftProjectController.getProjectByIdUsingGET(projectId);
      const project = rspns.data;
      AppStore.efh2Store.projectsStore.currentProject = project;
      if (project.session && project.session.note) {
        AppStore.efh2Store.basicDataForm.note = project.session.note;
      }
    } catch (error) {
      console.warn('error', error);
    }
  }

  @action.bound async getAllProjectComments(projectId) {
    try {
      const response = await ProjectCommentController.getProjectCommentsByProjectUuidUsingGET(projectId);
      if (response.data) {
        this.allProjectandDesignComments = response.data
      }
    } catch (error) {
      console.error(error)
    }
  }

  @action.bound async getUserInputs(projectId) {
    try {
      const response: any = await UserInputsController.getUserInputsByProjectUuidUsingGET(projectId);

      if (response.data) {
        AppStore.efh2Store.basicDataForm.dimUnitHydrogID = parseInt(response.data.duhName);
        if (response.data.rdtSmoothing === 'false') {
          AppStore.efh2Store.basicDataForm.rdt_smoothing = false;
        }
        if (response.data.rdtSmoothing === 'true') {
          AppStore.efh2Store.basicDataForm.rdt_smoothing = true;
        }
      }
    } catch (error) {
      console.error('getUserInputs error:', error);
    }
  }

  @action.bound async updateUserInputs() {
    const { basicDataForm, projectsStore } = AppStore.efh2Store;

    // defaulting notes field to empty string. -- Jared
    // Notes shifting to Design Comments not stored in this table
    const postJson = {
      projectUuid: projectsStore.currentProject.projectUuid,
      userInputNotes: '',
      rdtSmoothing: basicDataForm.rdt_smoothing,
      duhName: basicDataForm.dimUnitHydrogID,
    };

    try {
      await UserInputsController.updateUserInputsByProjectUuidUsingPOST(postJson);
    } catch (error) {
      console.error('updateUserInputs error:', error);
    }
  }

  private async loadProjectUserInput(projectId) {
    // comment out until refactor - WV 11-29-2021
    console.warn('Commented out loading user input from project.');
    this.isLoading = false;
  }
  @action.bound async saveUserInputToProject(jsonData: any) {
    const currentProject = AppStore.efh2Store.projectsStore.currentProject;
    const sessionUuid = AppStore.efh2Store.projectsStore.currentSessionId;
    if (currentProject && currentProject.projectUuid && localStorage.getItem('username')) {
      const postJson = [
        {
          id: 0,
          sessionUuid: sessionUuid,
          uiStateType: 'hydrology',
          sessionUiStateValue: JSON.stringify(jsonData),
          userId: String(localStorage.getItem('username') || ''),
        },
      ];

      try {
        await EftProjUserInputController.createProjectInputUsingPOST(postJson);
      } catch (error) {
        console.warn('saveUserInputToProject: error = ', error);
      }
    }
  }

  @action.bound async getUserPrefs() {
    const userPreferences = AppStore.userProfileStore.getPreference('analysis-hydrology-project');
    if (
      AppStore.efh2Store.basicDataForm.state === '' &&
      userPreferences &&
      AppStore.efh2Store.projectsStore.currentProject.projectTitle === '' &&
      userPreferences.state
    ) {
      AppStore.efh2Store.basicDataForm.state = userPreferences.state;
      const state = this.usStates.find((d) => d.abbreviation === AppStore.efh2Store.basicDataForm.state);
      if (state !== undefined && state.name !== undefined) {
        await this.changeStateSelection();
      }

      if (userPreferences.county) {
        const county = this.counties.find(
          (el) => el.county === userPreferences.county || el.county.includes(userPreferences.county)
        );

        AppStore.efh2Store.basicDataForm.county = county?.county;
        if (AppStore.efh2Store.basicDataForm.county) {
          this.changeCountySelection();
        }
      }
    }

    if (
      userPreferences &&
      AppStore.efh2Store.projectsStore.currentProject.projectTitle === '' &&
      userPreferences.client
    ) {
      const client = this.farmIDtoClient(String(userPreferences.client));
      AppStore.efh2Store.basicDataForm.client = client;
    }
    if (
      userPreferences &&
      AppStore.efh2Store.projectsStore.currentProject.projectTitle === '' &&
      userPreferences.dimUnitHydrogID
    ) {
      const hydro = this.dimUnitHydrogOptions.find((el) => el.id === +userPreferences.dimUnitHydrogID!);

      // addresses logic bug where dimUnitHydrogID may be undefined, default to 0
      if (hydro) {
        AppStore.efh2Store.basicDataForm.dimUnitHydrog = hydro.name;
        AppStore.efh2Store.basicDataForm.dimUnitHydrogID = hydro.id;
      } else {
        AppStore.efh2Store.basicDataForm.dimUnitHydrog = this.standard484String;
        AppStore.efh2Store.basicDataForm.dimUnitHydrogID = 0;
      }
    }
  }

  @action.bound farmIDtoClient(farmID) {
    let client = '';
    switch (String(farmID)) {
      case '1':
        client = 'Farmer Joe';
        break;
      case '2':
        client = 'Farmer Jane';
        break;
      case '3':
        client = 'Farmer Sue';
        break;
      default:
        client = '';
    }
    return client;
  }

  private resolveProceedWithValues?: (value: boolean) => void;

  @action.bound proceedWithValues(): Promise<boolean> {
    const currentPromise: Promise<boolean> = new Promise((resolve, reject) => {
      this.resolveProceedWithValues = resolve;
    });

    return currentPromise;
  }

  @action.bound accept(): void {
    if (this.resolveProceedWithValues) {
      //resolve the promise
      this.resolveProceedWithValues(true);

      //discard callback handle
      this.resolveProceedWithValues = undefined;
    }
  }

  @action.bound cancel(): void {
    if (this.resolveProceedWithValues) {
      //resolve the promise
      this.resolveProceedWithValues(false);

      //discard callback handle
      this.resolveProceedWithValues = undefined;
    }
  }

  @action.bound async getMetadata() {
    try {
      const response = await MetadataController.getAllMetadataUsingGET();
      const data = response.data;
      if (Array.isArray(data)) {
        AppStore.efh2Store.basicDataForm.metadata = JSON.stringify(data);
      } else { AppStore.efh2Store.basicDataForm.metadata = '' }
    } catch (error) {
      console.warn('getMetadata: error =', error);
    }
  }

  @action.bound countyCellRainfallRadio() {
    this.selectCountyRainfall = !this.selectCountyRainfall;
    // trigger change in rainfall discharge data table and clear plot
    if (this.selectCountyRainfall) {
      this.buildRainfallTableFromData(this.countyRainfallData);
    } else {
      this.buildRainfallTableFromData(this.cellRainfallData);
    }
  }

  @action.bound buildRainfallTableFromData(rainfallDataToUse) {
    const rainfallDischargeData: any = { table: [], plotData: {} };
    for (const key in rainfallDataToUse) {
      const rainValue = rainfallDataToUse[key].toFixed(2);
      const frequency = key.split('prec').pop();
      const row = {
        frequency: frequency,
        rainfall: rainValue,
        peakFlow: 0,
        runoff: 0,
        selected: false,
      };
      rainfallDischargeData.table.push(row);
    }

    for (const row of rainfallDischargeData.table) {
      const { frequency, rainfall } = row
      if (frequency) {
        AppStore.efh2Store.basicDataForm['prec' + frequency] = rainfall;
      } else { console.warn('something is wrong with frequency ', frequency) }
    }
    rainfallDischargeData.table.sort((a, b) => a.frequency - b.frequency);

    AppStore.efh2Store.rainfallDischargeTable = rainfallDischargeData.table;
    AppStore.efh2Store.rainfallPlotData = rainfallDischargeData.plotData;
  }

  @action.bound async callbackSlope(value) {
    AppStore.efh2Store.basicDataForm.watershedSlope = value;
    // trigger validation
    await this.validateField('watershedSlope', value);
    this.hideSlopeCalc = true;
  }

  @action.bound toggleSlopeCalc() {
    this.hideSlopeCalc = !this.hideSlopeCalc;
  }

  @action.bound async calcToC(method) {
    // trigger form validation first
    const requiredFields = ['watershedLen', 'runoffCN', 'watershedSlope'];
    for (const field of requiredFields) {
      const value = AppStore.efh2Store.basicDataForm[field];
      await this.validateField(field, value);
    }


    if (method === 'lag') {
      AppStore.efh2Store.basicDataForm.timeC = timeOfConcLagCalc(
        AppStore.efh2Store.basicDataForm.watershedLen,
        AppStore.efh2Store.basicDataForm.runoffCN,
        AppStore.efh2Store.basicDataForm.watershedSlope
      );
      AppStore.efh2Store.basicDataForm.timeC = timeOfConcLagCalc(
        AppStore.efh2Store.basicDataForm.watershedLen,
        AppStore.efh2Store.basicDataForm.runoffCN,
        AppStore.efh2Store.basicDataForm.watershedSlope
      );
      // validate again
      await this.validateField('timeC', AppStore.efh2Store.basicDataForm.timeC);
    }  //method === 'velocity' && valid
  }

  @action.bound async getHydroData() {
    const tempDuhOption = [{ name: this.standard484String, id: 0 }];
    // going to get rainfallDistID out of here as well as
    // dimensionless unit options 0 , 1 - 12
    try {
      const response = await Efh2ControllerApi.getAllEfh2RainHydgsUsingGET();
      const data = response.data as IEfh2RainHydgsByIdData[];

      // pull out ids 1-12 as options
      if (data.length) {
        for (const element of data) {
          if (element.id >= 1 && element.id <= 13) {
            const elementName = element.fileName.replace('.duh', '');
            const option = { id: element.id, name: elementName };
            tempDuhOption.push(option);
          } else {
            // pull out rainfallType/rainfallDist from file_name
            // make look up table, key is rainfallType value is id
            const step1 = element.fileName.replace('.tbl', '');
            const rainfallType = step1.replace('Type ', '');
            // temp fix - remove broken options
            const brokenOptions = ['AM SAMOA', 'B_(48)', 'B_6HR', 'I_(48)', 'II_(48)'];
            if (!brokenOptions.includes(rainfallType)) {
              this.rainDistOptions.push({
                rainfall_type_id: element.id,
                rainfall_type_name: rainfallType,
                rainfall_type_description: rainfallType,
              });
              this.rainfallDistIDLookup[rainfallType] = element.id;
            }
            // END temp fix - remove broken options
          }
        }
        tempDuhOption.sort((a, b) => {
          if (!a.name.split('_')[1] || !b.name.split('_')[1]) {
            return 0;
          }
          else {
            return parseInt(a.name.split('_')[1]) - parseInt(b.name.split('_')[1]);
          }
        })
        this.dimUnitHydrogOptions = tempDuhOption;
      }
    } catch (error) {
      console.warn('getHydroData: error =', error);
      this.error = true;
      this.errorMsg = (error as Error).message;
    }
  }

  @action.bound async handleSubmit(event?: any) {

    if (event) {
      event.preventDefault();
    }
    this.isLoading = true;
    // disable the submit button while processing
    this.disableSubmit = true;
    this.disableDownloads = true;
    this.error = false;
    //get metadata
    if (AppStore.efh2Store.basicDataForm.metadata === '') {
      await this.getMetadata();
    }

    // get dimUnitHydrog from options list using id
    const dimUnitHydrog: any = this.dimUnitHydrogOptions.find((element) => {
      return element.id === AppStore.efh2Store.basicDataForm.dimUnitHydrogID;
    });
    // convert strings to numbers
    AppStore.efh2Store.basicDataForm.runoffCN = +AppStore.efh2Store.basicDataForm.runoffCN;
    AppStore.efh2Store.basicDataForm.drainageArea = +AppStore.efh2Store.basicDataForm.drainageArea;
    AppStore.efh2Store.basicDataForm.watershedSlope = +AppStore.efh2Store.basicDataForm.watershedSlope;
    AppStore.efh2Store.basicDataForm.watershedLen = +AppStore.efh2Store.basicDataForm.watershedLen;

    // addresses logic bug where dimUnitHydrogID may be undefined, default to 0
    if (dimUnitHydrog) {
      AppStore.efh2Store.basicDataForm.dimUnitHydrog = dimUnitHydrog.name;
      AppStore.efh2Store.basicDataForm.dimUnitHydrogID = dimUnitHydrog.id;
    } else {
      AppStore.efh2Store.basicDataForm.dimUnitHydrog = this.standard484String;
      AppStore.efh2Store.basicDataForm.dimUnitHydrogID = 0;
    }

    this.updateUserInputs();

    if (this.resultsInputsModified.duh || this.resultsInputsModified.rdt || this.resultsInputsModified.hydrograph) {
      await this.createActivityLog();
      this.resultsInputsModified = {
        duh: false,
        rdt: false,
        hydrograph: false,
      };
    }

    const postJSON: Efh2InputParamsDeciSSReq = AppStore.efh2Store.basicDataForm;
    postJSON.projectUuid = AppStore.efh2Store.projectsStore.currentProject.projectUuid;
    postJSON.demServiceSelected = this.activityViewModel?.demSelectName;
    postJSON.projectComments = this.allProjectandDesignComments.flatMap(obj => obj.projectComment);
    const indexOfArr = AppStore.appConfig.demMapServices.findIndex(obj => obj.title === postJSON.demServiceSelected);
    if (indexOfArr !== -1) {
      postJSON.demServiceMetadataUrl = AppStore.appConfig.demMapServices[indexOfArr]?.metadata;
    }
    postJSON.adjustRcn = this.adjustedCurveNumber === "" ? 0 : this.adjustedCurveNumber; //sending 0 if cleared out of adjusted curve number

    try {
      const response = await HydroControllerApi.generateWinTR20ResultsGUsingPOST(postJSON);
      await HydroControllerApi.updateHydroUiStateByProjectUuidUsingPOST(
        {
          projectUuid: AppStore.efh2Store.projectsStore.currentProject.projectUuid,
          uiStateTypeId: 103,
          uiStateValue: AppStore.efh2Store.projectsStore.currentGpSessionId
        }
      )
      const data = response.data;

      // COMMENTED this.handleDlUrls(data.fileName) DUE TO DECOUPLING 
      //download the files to blobs so the user can click on the links


      // COMMENT OUT FOR NOW UNTIL API IS DONE
      // await this.saveUserInputToProject(data);
      // transform/sanitize the result before passing to logic
      // round values to 1 fixed decimal place
      this.handleNewCaseOutput(data);
      // console.log('handlesubmit',data)
      if (this.activityViewModel.hydrologyValidationError || this.error) {
        this.disableDownloads = true;
      } else {
        this.disableDownloads = false;
      }
    } catch (error) {
      console.warn('handleSubmit: error =', error);
      this.isLoading = false;
      this.error = true;
      this.errorMsg = (error as Error).message;
    }
    this.isLoading = false;
  }

  @action.bound async downloadReport() {
    this.isLoading = true;
    const allPayload: HydrologyReportReqDto = {
      aoiMapEnabled: true,
      commentsEnabled: true,
      demServiceEnabled: true,
      hydrographWithStrmAnlyEnabled: true,
      metadataEnabled: true,
      precpFreqDataEnabled: true,
      projectUuid: AppStore.efh2Store.projectsStore.currentProject.projectUuid,
      rainfallDistEnabled: true,
      runOffPeakDisEnabled: true
    }
    const response = await HydroControllerApi.generateEfh2PdfReportsGUsingPOST(allPayload, undefined, { responseType: 'blob' });
    const blobUrl = URL.createObjectURL(new Blob([response.data as any]));
    this.isLoading = false;
    return blobUrl;
  }

  @action.bound async downloadDetails() {
    this.isLoading = true;
    const response = await HydroControllerApi.downloadEfh2DetailsUsingGET(AppStore.efh2Store.projectsStore.currentProject.projectUuid, undefined, { responseType: 'blob' });
    const blobUrl = URL.createObjectURL(new Blob([response.data as any]));
    this.isLoading = false;
    return blobUrl;
  }

  @action.bound async createGISFilesLink() {
    this.isLoading = true;
    const sessionId = stores.AppStore.efh2Store.projectsStore.currentGpSessionId;
    const projectName = stores.AppStore.efh2Store.projectsStore.currentProject.projectTitle;

    let link = '';
    if (sessionId) {
      try {
        const result = await this.watershedApi.exportSessionEfh2(sessionId, projectName);
        link = result;
      } catch (error) {
        console.error(error);
      }
    }
    this.isLoading = false;
    return link;
  }

  @action.bound async handleDlUrls(fileName) {
    if (fileName) {
      // Having this here means the attachment table will be updated
      // whenever handleSubmit is called, thus whenever this
      // page is loaded with initPage.
      // Will use newly generated file name from generateWinTR20ResultsSiteSpecific
      await this.saveFileToAttachmentTable(fileName);
    }
  }
  private async saveFileToAttachmentTable(fileName: string) {
    const projectUuid = AppStore.efh2Store.projectsStore.currentProject.projectUuid;
    // Get from this projects existing attachment records
    const response = await ProjectAttachmentController.getProjectAttachmentsByProjectUuidUsingGET(projectUuid);
    if (response && response.data && response.data.length > 0) {
      // if files for this project -> do update instead
      this.updateFileAttachmentTable(fileName);
    } else {
      // no files for this project -> create these records
      const fileArray = this.buildFileArray(fileName, projectUuid);
      try {
        await ProjectAttachmentController.createProjectAttachmentsByProjectUuidUsingPOST(
          fileArray
        );
      } catch (error) {
        console.error(error);
      }
    }
  }
  private async updateFileAttachmentTable(fileName: string) {
    // Update existing attachment table records for this project
    const projectUuid = AppStore.efh2Store.projectsStore.currentProject.projectUuid;
    const fileArray = this.buildFileArray(fileName, projectUuid);
    try {
      const response = await ProjectAttachmentController.updateProjectAttachmentsByProjectUuidUsingPOST(
        fileArray
      );
    } catch (error) {
      console.error(error);
    }
  }
  private buildFileArray(fileName: string, projectUuid: string): ProjectAttachmentDto[] {
    const gpSessionId = AppStore.efh2Store.projectsStore.currentGpSessionId;
    const returnArray: ProjectAttachmentDto[] = [
      {
        projectUuid: projectUuid,
        projectFileExt: 'pdf',
        projectMimeTypeId: 1,
        projectFileName: fileName,
        status: 'add',
      },
      {
        projectUuid: projectUuid,
        projectFileExt: 'zip',
        projectMimeTypeId: 2,
        projectFileName: fileName,
        status: 'add',
      },
      {
        projectUuid: projectUuid,
        projectFileExt: 'zip',
        projectMimeTypeId: 2,
        projectFileName: gpSessionId,
        status: 'add',
      },
    ];
    return returnArray;
  }

  @action.bound async handleNewCaseOutput(data) {
    const percentNumber = 100;
    for (const index in data.prec) {
      let rainfall = data.prec[index];
      rainfall = Math.round(rainfall * percentNumber) / percentNumber;
      data.prec[index] = rainfall;
    }
    for (const index in data.peakFlow) {
      let peakFlow = data.peakFlow[index];
      peakFlow = Math.round(peakFlow * percentNumber) / percentNumber;
      data.peakFlow[index] = peakFlow;
    }
    for (const index in data.runoff) {
      let runoff = data.runoff[index];
      runoff = Math.round(runoff * percentNumber) / percentNumber;
      data.runoff[index] = runoff;
    }
    // transform data into table row format
    const tranformedData = {
      table: [] as {}[],
      plotData: {},
    };

    // catch NaNs and display error with this flag
    let foundNan = false;
    const hydrographData = {};
    for (const index in data.freq) {
      hydrographData[data.freq[index] + '-yr'] = data['hydsYr' + data.freq[index]];

      const row = {
        frequency: data.freq[index],
        rainfall: data.prec[index],
        peakFlow: data.peakFlow[index],
        runoff: data.runoff[index],
        selected: true,
      };
      tranformedData.table.push(row);

      // parse hydrograph data here
      const dataKeys = Object.keys(hydrographData);
      for (const key of dataKeys) {
        const dataPoints = hydrographData[key];
        tranformedData.plotData[key] = [];
        // start time is at index 3
        const startTimeIndex = 3;
        const timeIntervalIndex = 4;
        let xValue = dataPoints[startTimeIndex];
        // time interval is at index 4
        const timeInterval = dataPoints[timeIntervalIndex];
        // y_values start at index 7
        for (let i = 7; i < dataPoints.length; i++) {
          if (isNaN(+dataPoints[i])) {
            console.warn('Warning: This is not a number! ', dataPoints[i]);
            foundNan = true;
          }
          const xy = [xValue, dataPoints[i]];
          tranformedData.plotData[key].push(xy);
          xValue = xValue + timeInterval;
        }
      }
    }
    if (foundNan) {
      setTimeout(() => {
        this.error = true;
        this.errorMsg =
          'A problem was detected with some of the Discharge result values which may affect your hydrograph. Please contact support.';
      }, 1500);
    }
    // pass to parent and populate table with this data
    AppStore.efh2Store.rainfallDischargeTable = tranformedData.table;

    // Maximum Rainfall Validation
    let rainfallValidated: boolean = true;
    const maxRainfall = 70;
    AppStore.efh2Store.rainfallDischargeTable.map((item, i) => {
      if (item.rainfall < 0 || item.rainfall > maxRainfall) {
        rainfallValidated = false;
      }
    });

    if (!rainfallValidated) {
      this.activityViewModel.hydrologyValidationError = true;
      MessageCenter.addErrorFromCode('Hydro_40', [
        {
          callback: () => {
            MessageCenter.clearMessages();
            this.cancel();
          },
          text: 'Cancel',
        },
      ]);

      const dialogResult: boolean = await this.proceedWithValues();

      if (dialogResult !== true) {
        return;
      }
    }

    AppStore.efh2Store.rainfallPlotData = tranformedData.plotData;
  }

  @action.bound resetErrorAndSuccess() {
    this.error = false;
    this.errorMsg = '';
    this.disableSubmit = false;
  }

  @action.bound async getStateCountyRainfallFromGrid(gridData) {
    this.cellVsCountyBtnsDisabled = true;
    try {
      const response = await Efh2ControllerApi.rainfallG1KUsingPOST(gridData);
      const data = response.data as IRainfallGridResponse;
      const userPreferences = AppStore.userProfileStore.getPreference('analysis-hydrology-project');
      if (
        data.state &&
        data.county &&
        AppStore.efh2Store.projectsStore.currentProject.projectUuid !== '' &&
        userPreferences
      ) {
        userPreferences.state = data.state;
        userPreferences.county = data.county;
        AppStore.efh2Store.basicDataForm.state = data.state;
        await this.getCountiesFromState(data.state, true);
        // data.county does not include the rainfall type so will
        // need to match with the list of counties for the right one.
        const matchCounty = this.counties.find((el) => {
          return el.county.toLowerCase().includes(data.county.toLowerCase());
        });
        if (matchCounty && matchCounty.county) {
          AppStore.efh2Store.basicDataForm.county = matchCounty.county;
        } else {
          console.warn('No county match found for ', data.county);
        }
      }
      if (data.precgrid) {
        this.cellVsCountyBtnsDisabled = false;
        const rainfallKeys = Object.keys(this.cellRainfallData);
        for (const index of data.precgrid.keys()) {
          const rainfall = data.precgrid[index];
          this.cellRainfallData[rainfallKeys[index]] = rainfall;
        }
        this.buildRainfallTableFromData(this.cellRainfallData);
      }
    } catch (error) {
      console.warn('getStateCountyRainfallFromGrid: error =', error);
    }
  }
  @action.bound buildCountySelectionAndGet(data: StateCounty[]) {
    // filter out duplicate 'county' entries
    const uniqueCounties = [...new Map(data.map((item) => [item.county, item])).values()];
    // sort alphabetically
    uniqueCounties.sort(function (a, b) {
      if (a.county?.length && b.county?.length) {
        if (a.county < b.county) {
          return -1;
        }
        if (a.county > b.county) {
          return 1;
        }
      }
      return 0;
    });
    this.counties = uniqueCounties;
    // reset selection if not in counties
    const county = this.counties.find(
      (d) =>
        d.county === AppStore.efh2Store.basicDataForm.county ||
        d.county.includes(AppStore.efh2Store.basicDataForm.county)
    );
    if (county === undefined) {
      AppStore.efh2Store.basicDataForm.county = '';
      // have to do this to clear combobox
      const countyInput: any = document.getElementById('county');
      countyInput.value = '';
    }
  }

  // This function is for getStateCountyRainfallFromGrid
  @action.bound async getCountiesFromState(state: string, getNewRainfallData: boolean) {
    if (state) {
      try {
        const response = await Efh2ControllerApi.getAllCountiesByStateUsingGET(state);
        const data = response.data;
        this.buildCountySelectionAndGet(data);
        const county = this.counties.find((county) => {
          const lowerCaseCounty = county.county.toLowerCase();
          if (lowerCaseCounty.includes(AppStore.efh2Store.basicDataForm.county.toLowerCase())) {
            return county;
          }
        });
        if (county === undefined) { console.warn('county is underfined! Couldnt find a match for: ', AppStore.efh2Store.basicDataForm.county) }
        // updates rainfall table with new county data
        if (getNewRainfallData) { await this.getRainfallFromCounty(county) }
      } catch (error) {
        console.warn('getCountiesFromState: error =', error);
        this.error = true;
        this.errorMsg = (error as Error).message;
      }
    }
  }

  // used for for cell/grid rainfall workflow
  @action.bound async getRainfallFromCounty(county) {
    if (county === undefined) {
      console.warn('no county value');
      return;
    } else {
      try {
        const response = await Efh2ControllerApi.getRainfallByIdUsingGET(county.id);
        const data = response.data as IRainfallByIdData;
        //transform the data for local use before passing on to
        for (const key in data) {
          if (key.startsWith('yr_')) {
            // change precision of 24-hour rainfall values to 2 decimal place
            let rainfall: number = data[key];
            rainfall = Math.round(rainfall * 100) / 100;
            data[key] = rainfall;
          }
        }
        // these are needed for POST upon submit
        AppStore.efh2Store.basicDataForm.rainfallType = data.rainfallType;
        AppStore.efh2Store.basicDataForm.rainfallTypeID = data.id;
        AppStore.efh2Store.basicDataForm.rainfallDist = data.rainfallType;
        AppStore.efh2Store.basicDataForm.rainfallDistID = this.rainfallDistIDLookup[data.rainfallType];
        this.buildRainfallTable(county, data);
      } catch (error) {
        console.warn('changeCountySelection: error =', error);
        this.error = true;
        this.errorMsg = (error as Error).message;
      }
    }
  }

  @action.bound buildRainfallTable(county, data) {
    if (county === undefined || data === undefined) {
      console.warn('no county or data value');
      return;
    }
    data.table = [];
    data.plotData = {};
    const responseKeys = Object.keys(data);
    for (const key of responseKeys) {
      if (key.includes('yr_')) {
        const rainfall = data[key];
        const frequency = key.split('_').pop();
        // include rainfall data in prep for /NewCase POST
        // this is county rainfall which is the default selection
        if (frequency) {
          AppStore.efh2Store.basicDataForm['prec' + frequency] = rainfall;
        } else {
          console.warn('something is wrong with frequency ', frequency);
        }

        // make copy in order to toggle
        this.countyRainfallData['prec' + frequency] = rainfall;
        const row = {
          frequency: frequency,
          rainfall: rainfall,
          peakFlow: 0,
          runoff: 0,
          selected: false,
        };
        data.table.push(row);
      }
    }
    data.table.sort((a, b) => a.frequency - b.frequency);

    // catch error if rainfall data is all 0s
    const rainfallIsAllZero = data.table.every((item) => item.rainfall === 0);
    if (rainfallIsAllZero) {
      this.errorMsg = 'No rainfall data available for ' + county.county + ' county.';
      this.error = true;
      this.disableSubmit = true;
    }
    AppStore.efh2Store.rainfallDischargeTable = data.table;
    AppStore.efh2Store.rainfallPlotData = data.plotData;
  }

  @action.bound async changeStateSelection() {
    this.resetErrorAndSuccess();
    // when state selection is changed update county selection
    const state = AppStore.efh2Store.basicDataForm.state;

    AppStore.userProfileStore.setPreference('analysis-hydrology-project', 'state', state);

    if (state === '') {
      console.warn('no state value');
      // clear county
      AppStore.efh2Store.basicDataForm.county = '';
      // have to do this to clear combobox
      const countyInput: any = document.getElementById('county');
      if (countyInput) countyInput.value = '';
      return;
    }

    try {
      const response = await Efh2ControllerApi.getAllCountiesByStateUsingGET(state);
      const data = response.data;
      this.buildCountySelectionAndGet(data);
    } catch (error) {
      console.warn('changeStateSelection: error =', error);
      this.error = true;
      this.errorMsg = (error as Error).message;
    }
  }

  // makes GET request for rainfall data and populates rainfall discharge table
  @action.bound async changeCountySelection() {
    this.resetErrorAndSuccess();
    if (AppStore.efh2Store.basicDataForm.county === '' || AppStore.efh2Store.basicDataForm.county === undefined) {
      console.warn('no county value');
      return;
    }
    const county = this.counties.find((county) => county.county === AppStore.efh2Store.basicDataForm.county);
    const id = county?.id;

    if (county && county.county && AppStore.userProfileStore.userPreferences) {
      AppStore.userProfileStore.setPreference('analysis-hydrology-project', 'county', county.county);
    }
    try {
      const response = await Efh2ControllerApi.getRainfallByIdUsingGET(id);
      const data = response.data as IRainfallByIdData;
      //transform the data for local use before passing on to
      for (const key in data) {
        if (key.startsWith('yr_')) {
          // change precision of 24-hour rainfall values to 2 decimal place
          let rainfall: number = data[key];
          rainfall = Math.round(rainfall * 100) / 100;
          data[key] = rainfall;
        }
      }
      // these are needed for POST upon submit
      AppStore.efh2Store.basicDataForm.rainfallType = data.rainfallType;
      AppStore.efh2Store.basicDataForm.rainfallTypeID = data.id;
      AppStore.efh2Store.basicDataForm.rainfallDist = data.rainfallType;
      AppStore.efh2Store.basicDataForm.rainfallDistID = this.rainfallDistIDLookup[data.rainfallType];
      // Post processing to create table
      this.buildRainfallTable(county, data);
    } catch (error) {
      console.warn('changeCountySelection: error =', error);
      this.error = true;
      this.errorMsg = (error as Error).message;
    }
  }

  // keeps data model up to date with form
  @action.bound async handleInputChange(event) {
    const target = event.target;

    if (target.id === 'dimUnitHydrogID') {
      AppStore.efh2Store.basicDataForm[target.name] = parseInt(target.value);
      this.resultsInputsModified.duh = true;
    } else if (target.id === 'rdt_smoothing') {
      AppStore.efh2Store.basicDataForm[target.name] = target.value === 'true';
      this.resultsInputsModified.rdt = true;
    } else if (target.type === 'checkbox') {
      AppStore.efh2Store.basicDataForm[target.name] = target.checked;
    } else if (target.name === 'projectName') {
      this.newProjectName = target.value;
    } else if (target.name === 'adjustedCurveNumber') {
      AppStore.efh2Store.basicDataForm.adjustRcn = target.value;
      this.adjustedCurveNumber = target.value;
    } else {
      AppStore.efh2Store.basicDataForm[target.name] = target.value;
    }
    if (target.name !== 'adjustedCurveNumber') { //to not run validation onChange for adjustedCurveNumber
      await this.validateField(target.name, target.value)
    }
    this.disableSubmit = false;
    this.disableDownloads = true;
  }

  @action.bound handleOnBlurRounding(event: { target: any }) {
    const target = event.target;
    const name = target.name;
    const oldValue = target.value;
    let newValue;
    switch (name) {
      case 'drainageArea':
      case 'watershedSlope':
      case 'timeC':
        newValue = Math.round(oldValue * 100) / 100; // to hundredth
        break;
      case 'watershedLen':
      case 'runoffCN':
        newValue = Math.round(oldValue); // to whole
        break;
      default:
        break;
    }
    AppStore.efh2Store.basicDataForm[name] = newValue;
  }

  @action.bound async handleStateInputChange(event) {
    await this.handleInputChange(event);
    await this.changeStateSelection();
  }
  @action.bound async handleCountyInputChange(event) {
    if (this.enableCountyOnchange) {
      await this.handleInputChange(event);
      await this.changeCountySelection();
    }
  }

  // Form Validation model
  @observable formValidation = {
    formErrors: {
      client: '',
      state: '',
      county: '',
      rainfallType: '',
      drainageArea: '',
      watershedLen: '',
      timeC: '',
      runoffCN: '',
      watershedSlope: '',
      adjustedCurveNumber: '',
    },
    clientValid: false,
    stateValid: false,
    countyValid: false,
    rainfallTypeValid: false,
    drainageAreaValid: false,
    watershedLenValid: false,
    timeCValid: false,
    runoffCNValid: false,
    watershedSlopeValid: false,
    adjustedCurveNumber: false,
    adjustedCurveNumberValid: false,
    formValid: false,
  };
  @observable projectNameValidation = {
    projectNameErrors: '',
    projectNameValid: false,
  };

  // form validation by field
  @action.bound async validateField(fieldName, value) {
    // connects form field to validation table
    const keyValid = fieldName + 'Valid';
    let fieldValid = this.formValidation[keyValid];
    const fieldValidationErrors = this.formValidation.formErrors;

    switch (fieldName) {
      case 'client':
        // no special chars
        fieldValid = value != '' && noSpecialChars(value);
        fieldValidationErrors[fieldName] = fieldValid ? '' : 'is required and only numbers and letters are allowed';
        break;
      case 'state':
      case 'county':
        fieldValid = value.length > 0;
        fieldValidationErrors[fieldName] = fieldValid ? '' : 'must make a selection';
        break;
      case 'rainfallType':
        fieldValid = value !== '';
        fieldValidationErrors[fieldName] = fieldValid ? '' : 'must make a selection';
        break;
      case 'drainageArea':
        fieldValid = value >= 1 && value <= 2000;
        fieldValidationErrors[fieldName] = fieldValid ? '' : 'must be between 1 and 2000';
        break;
      case 'watershedLen':
        fieldValid = value >= 200 && value <= 26000;
        fieldValidationErrors[fieldName] = fieldValid ? '' : 'must be between 200 and 26000';
        break;
      case 'timeC':
        if (value < 0.1) {
          AppStore.efh2Store.basicDataForm.timeC = 0.1;
          fieldValidationErrors[fieldName] = '';
          await MessageCenter.addNotificationFromCode('Hydro_108');
        } else {
          fieldValid = value >= 0.1 && value <= 10;
          fieldValidationErrors[fieldName] = fieldValid ? '' : 'must be between 0.1 and 10';
        }
        break;
      case 'runoffCN':
        fieldValid = value >= 40 && value <= 98;
        fieldValidationErrors[fieldName] = fieldValid ? '' : 'must be between 40 and 98';
        break;
      case 'watershedSlope':
        fieldValid = value >= 0.5 && value <= 64;
        fieldValidationErrors[fieldName] = fieldValid ? '' : 'must be between 0.5 and 64';
        break;
      case 'adjustedCurveNumber':
        if (value === '') {
          await MessageCenter.addNotificationFromCode('Hydro_107')
          fieldValidationErrors[fieldName] = ''
          break
        }
        if (value < 30 || value > 98) {
          fieldValidationErrors[fieldName] = ' '
          await MessageCenter.addNotificationFromCode('HYDRO_48')
          this.disableSubmit = true;
        }
        else if (Math.abs(AppStore.efh2Store.basicDataForm.runoffCN - value) > 15) {
          fieldValidationErrors[fieldName] = ' '
          await MessageCenter.addNotificationFromCode('HYDRO_106')
          this.disableSubmit = true;
        } else {
          fieldValid = true;
          fieldValidationErrors[fieldName] = '';
          await MessageCenter.addNotificationFromCode('Hydro_107');
        }
        break;
      case 'projectName':
        const isUntitled = value.toLowerCase().includes('untitled project');
        this.projectNameValidation.projectNameErrors = isUntitled
          ? 'Project Name cannot include "Untitled Project"'
          : '';
        if (!isUntitled) {
          this.projectNameValidation.projectNameValid = value !== '' && noSpecialChars(value);
          this.projectNameValidation.projectNameErrors = this.projectNameValidation.projectNameValid
            ? ''
            : 'Project Name is required and only numbers and letters are allowed';
        } else {
          this.projectNameValidation.projectNameValid = false;
        }

        break;
      default:
        break;
    }
    if (fieldName !== 'projectName') {
      this.formValidation.formErrors = fieldValidationErrors;
      this.formValidation[keyValid] = fieldValid;
      this.validateForm();
    }
  }

  // checks if there are any error msgs over entire form
  @action.bound validateForm() {
    let valid = true;
    for (const key in this.formValidation.formErrors) {
      if (!this.formValidation[key + 'Valid']) {
        valid = false;
      }
    }
    this.formValidation.formValid = valid;
  }

  @action.bound errorClass(field) {
    const errorMessage =
      field === 'projectName' ? this.projectNameValidation.projectNameErrors : this.formValidation.formErrors[field];
    return errorMessage.length === 0 ? '' : ' usa-input--error';
  }
  // END Form Validation model

  //--- Save New Project
  @action.bound saveProjModalToggle() {
    this.projectSaveModalOpen = !this.projectSaveModalOpen;
  }

  // Create a new project to save work done on the RCN page
  @action.bound async saveNewProject(projectName: string) {
    const efh2Store = stores.AppStore.efh2Store;
    efh2Store.projectsStore.init();
    // from: createInvisibleProject - GISBoxVM:657
    let userName = stores.AppStore.userProfileStore.userName;
    if (userName === '' && localStorage.username) {
      userName = localStorage.username;
    }

    const project = {
      currentUser: userName,
      projectTitle: projectName,
      projectClassId: 4, // 4 - analysis-hydrology
    };

    // Send Post Request
    const postJSON: ICreateProjectPOST = project;
    try {
      const response = await EftProjectController.createProjectUsingPOST(postJSON);
      const data = (response.data as unknown) as ProjectDataObject;

      if (data.projectUuid) {
        // update proj id in url

        efh2Store.projectsStore.currentProject = data as any;
        // this.updateNotesFromSession();
        //save RCN data
        if (efh2Store.rcnData && efh2Store.rcnData.data) {
          const currentProject = AppStore.efh2Store.projectsStore.currentProject;
          if (currentProject && currentProject.projectUuid && localStorage.getItem('username')) {
            const postJson = [
              {
                projectUuid: currentProject.projectUuid,
                userInputType: 'rcn1',
                userInputJson: JSON.stringify(efh2Store.rcnData),
                userId: String(localStorage.getItem('username') || ''),
              },
            ];
            // make POST to save user input here
            // COMMENT OUT FOR NOW UNTIL API IS DONE
            // await this.projectUserInputAPI.saveProjectUserInput(postJson);
            efh2Store.rcnData = []
          }
        }
        const inputs = [efh2Store.basicDataForm];
        //save r&d data
        const RainfallInputData = {
          Inputs: inputs,
        };
        // COMMENT OUT FOR NOW UNTIL API IS DONE
        // await this.saveUserInputToProject(RainfallInputData);
      } else {
        // handle error case here until catch is working
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.saveProjModalToggle();
    }
  }
  //--- End of Project Saving

  public async createActivityLog() {
    if (this.resultsInputsModified.duh) {
      const activityJson = {
        activityContent: 'DUH Modified',
        appAccessed: 'TR20 Results',
        comment: `Dimensionless Unit Hydrograph changed to ${AppStore.efh2Store.basicDataForm.dimUnitHydrogID}`,
        createdBy: UserIdentity.username,
        crudCode: 'Update',
        deleted: 0,
        lastChangedBy: UserIdentity.username,
        projUuid: AppStore.efh2Store.projectsStore.currentProjectId,
        projectStatus: 'Started',
        sessionUuid: AppStore.efh2Store.projectsStore.currentProject.sessionList[0].sessionUuid,
        userName: UserIdentity.username,
      };
      await ActivityLogController.createActivityLogUsingPOST(activityJson);
    }
    if (this.resultsInputsModified.rdt) {
      const activityJson = {
        activityContent: 'Smoothing Modified',
        appAccessed: 'TR20 Results',
        comment: `Smooth Rainfall Distribution changed to ${AppStore.efh2Store.basicDataForm.rdt_smoothing}`,
        createdBy: UserIdentity.username,
        crudCode: 'Update',
        deleted: 0,
        lastChangedBy: UserIdentity.username,
        projUuid: AppStore.efh2Store.projectsStore.currentProjectId,
        projectStatus: 'Started',
        sessionUuid: AppStore.efh2Store.projectsStore.currentProject.sessionList[0].sessionUuid,
        userName: UserIdentity.username,
      };
      await ActivityLogController.createActivityLogUsingPOST(activityJson);
    }
  }

  get disableAdjustedCurve() {
    // Adjusted Curve Number Input is currently enabled only for TX and OK
    if (stores.AppStore.efh2Store.basicDataForm.state.toLowerCase() === "tx" || stores.AppStore.efh2Store.basicDataForm.state.toLowerCase() === "texas" ||
      stores.AppStore.efh2Store.basicDataForm.state.toLowerCase() === "ok" || stores.AppStore.efh2Store.basicDataForm.state.toLowerCase() === "oklahoma") {
      return false;
    } else {
      return true;
    }
  }
}
